<div *ngIf="mode === 'view'" class="field field_size_{{ size ? size : 'l' }}">
  <div *ngIf="name" class="field__name">{{ name }} &nbsp;</div>
  <div class="field__value">
    <app-parse-multimedia-links class="text_size_{{ size }}" [value]="value"></app-parse-multimedia-links>
  </div>
</div>
